import { React, useEffect, useRef, useState } from "react";
import "./infoTimeline.css";
import mapIcon from '../../assets/icons/mapIcon.svg';
import busIcon from '../../assets/icons/busIcon.svg';
import accessibilityIcon from '../../assets/icons/accessibilityIcon.svg';
import foodIcon from '../../assets/icons/foodIcon.svg';
import shieldIcon from '../../assets/icons/shieldIcon.svg';


const TIMELINE_ITEMS = [
  {
    id: 1,
    side: "left",
    icon: mapIcon,
    title: "Event Details",
    content: [
      "January 25 to February 5, 2027",
      "Egypt International Exhibition Center (EIEC)",
      "Daily: 10 AM - 8 PM",
    ],
  },
  {
    id: 2,
    side: "right",
    icon: busIcon,
    title: "Transportation",
    content: [
      "Metro & bus routes available",
      "Parking nearby",
      "Ride apps accessible",
    ],
  },
  {
    id: 3,
    side: "left",
    icon: accessibilityIcon,
    title: "Accessibility",
    content: [
      "Wheelchair access",
      "Accessible restrooms",
      "Reserved seating",
    ],
  },
  {
    id: 4,
    side: "right",
    icon: foodIcon,
    title: "Food & Drink",
    content: [
      "Food court available",
      "Coffee shops",
      "Rest areas",
    ],
  },
  {
    id: 5,
    side: "left",
    icon: shieldIcon,
    title: "Safety & Security",
    content: [
      "Bag checks at entry",
      "Medical support",
      "Security staff onsite",
    ],
  },
];

export default function InfoTimeline() {
  const timelineRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    function handleScroll() {
        if (!timelineRef.current) return;
      
        const section = timelineRef.current;
        const rect = section.getBoundingClientRect();
      
        const windowHeight = window.innerHeight;
      
        const start = windowHeight * 0.8;
      
        const end = -rect.height;
      
        const current = start - rect.top;
      
        const percent = Math.min(
          Math.max(current / (start - end), 0),
          1
        );
      
        setProgress(percent * 100);
      }
  
    handleScroll();
  
    window.addEventListener("scroll", handleScroll);
  
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="timelineSection" ref={timelineRef}>

      <div className="timelineLine">
        <div
          className="timelineLineProgress"
          style={{ height: `${progress}%` }}
        />
      </div>

      {TIMELINE_ITEMS.map((item) => (
        <div
          key={item.id}
          className={`timelineRow ${item.side}`}
        >

          <div className="timelineCard">
            <h3>{item.title}</h3>

            <ul>
              {item.content.map((text, i) => (
                <li key={i}>{text}</li>
              ))}
            </ul>
          </div>

          <div className="timelineIcon">
            <img src={item.icon} alt="" />
          </div>

        </div>
      ))}

    </section>
  );
}